export const organizationFarmRoutes = {
  tasks: {
    organization: '/company/:companyId/tasks',
    property: '/company/:companyId/property/:propertyId/tasks'
  },
  reports: {
    organization: '/company/:companyId/reports',
    property: '/company/:companyId/property/:propertyId/reports'
  },
  reportsList: {
    organization: '/company/:companyId/reports-list',
    property: '/company/:companyId/property/:propertyId/reports-list'
  },
  warehouses: {
    organization: '/company/:companyId/warehouses',
    property: '/company/:companyId/property/:propertyId/warehouses'
  },
  smartPlan: {
    organization: '/company/:companyId/smart-plan/*',
    property: '/company/:companyId/property/:propertyId/smart-plan/*'
  },
  nemaDigital: {
    organization: '/company/:companyId/nemadigital',
    property: '/company/:companyId/property/:propertyId/nemadigital'
  },
  subscriptionManagement: {
    organization: '/company/:companyId/subscription-management',
    property: '/company/:companyId/property/:propertyId/subscription-management'
  }
} as const;
